export default {
	colors: {
		background: "#f7f7f7",
		black: "#1d1b38",
		blue: "#336d88",
		lightBlue: "#336d88",
		lightGray: "#929aab",
		white: "#f7f7f7",
	},
	transitions: "0.3s",
};
